import { camelCase } from 'lodash';

import { ExceptionType } from '../../shared/enums/exception-type.enum';

export class Exception<T> {
  id: number = null;
  customName: string = null;
  exceptionType: ExceptionType = null;
  alertEmail: string = null;
  alertMobileNumber: string = null;
  details: T = null;
  vehicleIds: number[] = [];

  constructor(obj?: any) {
    for (const field in obj) {
      const camelCasedField = camelCase(field);
      if (typeof this[camelCasedField] !== 'undefined') {
        this[camelCasedField] = obj && obj[field];
      }
    }
  }
}
